module.exports = __webpack_public_path__ + "static/img/index2.ebe60fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/index2.png
// module id = MSP3
// module chunks = 1